<template>
    <section class="section">
        <operate v-for="v in activities" :key="v.id" :nick="nick" :thumb="thumb" :v="v"></operate>
        <div v-if="has_more">
            <div v-show="is_loading" class="loading-box">
                <i class="loading"></i>
                正在加载中，请稍候...
            </div>
            <div v-show="loading_error" @click="reload" class="loading-box cp">
                <span class="error-text">请求超时,</span>
                <span class="dc"> 点击重新载入</span>
            </div>
        </div>
        <div v-show="!has_more" class="loading-box">你已经到达了世界的尽头</div>
    </section>
</template>

<script>
    import operate from '../dancer/ActivityOperate';

    export default {
        components: {
            operate
            // player,
            // editor
        },
        props: {
            nick: String,
            thumb: String,
        },
        data: () => ({
            last_time: '',
            last_id: 0,
            activities: [],
            enlarge: [],
            is_loading: false,
            loading_error: false,
            has_more: true,
            comments: [],
            /*throttle: {
                wait: 250,
                mustRun: 250,
                timeout: 0,
                startTime: new Date,
            }*/
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
            state() {
                return this.$store.state;
            },
            video() {
                return this.state.video;
            },
            user() {
                return this.state.user;
            },
            sign() {
                return this.state.sign;
            },
            emoji() {
                return this.state.emoji;
            },
            uid() {
                return this.user.id;
            },
        },

        methods: {
            async like(v) {
                if (v.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_liking = true;

                if (v.is_like) {// 点赞
                    v.likes--;
                    v.is_like = false;
                    await this.api.del(`dancers/activities/${v.id}/like`).catch(e => {
                        this.alert.err(e.message);
                        v.v.likes++;
                        v.is_like = true;
                    });
                } else {// 取消点赞
                    v.likes++;
                    v.is_like = true;
                    await this.api.post(`dancers/activities/${v.id}/like`).catch(e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = false;
                    });
                }

                v.is_liking = false;
            },
            async collect(v) {
                if (v.is_collecting) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_collecting = true;

                if (v.is_collect) {// 点赞
                    v.is_collect = false;
                    await this.api.del(`dancers/activities/${v.id}/collect`).catch(e => {
                        this.alert.err(e.message);
                        v.is_collect = true;
                    });
                } else {// 取消点赞
                    v.is_collect = true;
                    await this.api.post(`dancers/activities/${v.id}/collect`).catch(e => {
                        this.alert.err(e.message);
                        v.is_collect = false;
                    });
                }

                v.is_collecting = false;
            },
            async likeComment(v, isTop = false) {
                if (v.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_liking = true;
                const comment = isTop ? 'comment' : 'reply';

                if (v.is_like) {// 点赞
                    v.likes--;
                    v.is_like = false;
                    await this.api.del(`dancers/activities/${comment}/${v.id}/like`).catch(e => {
                        this.alert.err(e.message);
                        v.likes++;
                        v.is_like = true;
                    });
                } else {// 取消点赞
                    v.likes++;
                    v.is_like = true;
                    await this.api.post(`dancers/activities/${comment}/${v.id}/like`).catch(e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = false;
                    });
                }

                v.is_liking = false;
            },
            options: (v, autoplay) => ({
                width: 576,
                height: v.height / v.width * 576,
                fluid: false,
                autoplay: autoplay, //如果true,浏览器准备好时开始播放。 enlarge > -1
                sources: [{
                    type: 'video/mp4',
                    src: v.src //url地址
                }],
                poster: v.thumb, //你的封面地址
            }),
            changeEnlarge(v, kk) {
                // this.$set(v, 'autoplay', true);
                // console.log(kk, kk > -1);
                this.$set(v, 'enlarge', kk);
            },
            nextPage() {
                //文档内容实际高度（包括超出视窗的溢出部分）
                const scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight),
                    //滚动条滚动距离
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
                    //窗口可视范围高度
                    clientHeight = window.innerHeight || Math.min(document.documentElement.clientHeight, document.body.clientHeight);

                if ((clientHeight + scrollTop >= scrollHeight - 1000) && !this.loading_error) this.load();
            },
            reload() {
                this.loading_error = false;
                this.load();
            },
            async load() {
                if (this.is_loading) return;
                this.is_loading = true;

                let {last_time, last_id} = this,
                    err = false,
                    activity = await this.api.get(`dancers/${this.id}/activities`, {last_time, last_id}).catch(() => {
                        this.is_loading = false;
                        this.loading_error = true;
                        err = true;
                    });

                if (err) return;

                if (activity.length > 9) {
                    this.activities = this.activities.concat(activity);
                    const last = activity[activity.length - 1];
                    this.last_time = last.addtime;
                    this.last_id = last.id;
                    this.$nextTick(() => {// 等待DOM渲染完毕后 延迟1秒再允许用户继续加载数据
                        setTimeout(() => {
                            this.is_loading = false;
                        }, 1000);
                    });
                } else {
                    this.has_more = false;
                }

            },

            showEditor(v) {
                this.$set(v, 'area', !v.area);
            }
            /*throttle(func, wait, mustRun) {
                let startTime = new Date(), timeout;
                return function () {
                    const curTime = new Date();
                    clearTimeout(timeout);

                    if (curTime - startTime >= mustRun) {// runHandler
                        // func.apply(this, arguments);
                        func();
                        startTime = curTime;
                    } else {// resetTimeout
                        timeout = setTimeout(func, wait);
                    }
                };
            },*/
            /*scroll() {
                const curTime = new Date, {throttle} = this;
                clearTimeout(throttle.timeout);

                if (curTime - throttle.startTime >= throttle.mustRun) {// runHandler
                    throttle.startTime = curTime;
                    this.nextPage();
                } else {// resetTimeout
                    throttle.timeout = setTimeout(this.nextPage, throttle.wait);
                }
            }*/
        },
        mounted() {
            // 可以采用节流函数
            window.addEventListener('scroll', this.nextPage);
        },
        beforeMount() {
            this.load();
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.nextPage);
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/comment.css";
    @import "../../../static/css/views/dancer/activity.css";

</style>



// WEBPACK FOOTER //
// src/views/dancer/Activity.vue